module.exports = __webpack_public_path__ + "img/cibg.d498302e.svg";